<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-12 m-0 no-max-w home-div">
          <Toast/>
          <div class="page-wrapper mt-5">
            <div class="filters d-flex gap-2 mb-3">
              <select v-model="filters.type" class="form-select">
                <option value="">All types</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>

              <select v-model="filters.isPremium" class="form-select">
                <option :value="null">All</option>
                <option :value="true">Premium</option>
                <option :value="false">Free</option>
              </select>

              <select v-model.number="filters.ascendantSignId" class="form-select">
                <option v-for="sign in signs" :value="sign.id" :key="sign">{{sign.name}}</option>
              </select>

              <input
                  type="date"
                  v-model="filters.startDateFrom"
                  class="form-control"
              />
              <input
                  type="date"
                  v-model="filters.startDateTo"
                  class="form-control"
              />
            </div>

            <AstopiaTable
                ref="astopiaTable"
                :columns="columns"
                :url="'/admin/weekly-monthly'"
                :defaultPostData="weeklyMonthlyQuery"
                :axiosDataName="'response'"
                :totalDataName="'totalCount'"
                :sort-field="'id'"
                :dataPagination="false"
                :isOnlydata="false"
                :pagePagination="true"
                :addButton="true"
                @detail-see="detailSee"
                @add-button="openCreateModal"
                @delet-see="openDeleteModal"
                @getLookups-button="openCsvUploadModal"
                :getLookupsButton="'Upload csv'"
                :selectedObj3="true"
                :optionsList="optionsList"
                :multiple="true"
            />

            <button
                class="btn btn-danger mt-3 mb-3"
                type="button"
                @click="bulkDeleteAll"
            >
              Delete Selected
            </button>

            <CreateModal
                :show="showCreateModal"
                modalTitle="Create Weekly / Monthly"
                modalWidth="70%"
                :formFields="createFormFields"
                @saveEndpoint="createObj"
                method="post"
                @hide="showCreateModal = false"
                @success="refreshTable"
            />

            <EditModal
                :show="showEditModal"
                modalTitle="Edit Weekly / Monthly"
                modalWidth="50%"
                :formFields="editFormFields"
                :detailEndpoint="`/admin/weekly-monthly/${selectedObjId}`"
                :axiosDataName="'response'"
                @saveEndpoint="editObj"
                method="put"
                :totalDataName="'response'"
                :isOnlydata="true"
                @hide="showEditModal = false"
            />

            <DeleteModal
                :show="showDeleteModal"
                :itemId="selectedDeleteObj"
                modalTitle="Delete Weekly / Monthly"
                deleteMessage="Are you sure you want to delete this item?"
                confirmButtonText="Yes"
                :deleteEndpoint="`/admin/weekly-monthly/${selectedDeleteId}`"
                @update:isVisible="showDeleteModal = false"
                @delete-success="refreshTable"
            />
          </div>

        </div>
      </div>
    </div>
  </main>
</template>

<script>
import AstopiaTable from "@/components/Tables/AstopiaTable.vue";
import Toast from "primevue/toast";
import Swal from "sweetalert2";

export default {
  name: 'ContentUploadList',
  components: {Toast, AstopiaTable },
  data() {
    return {
    columns: [
        { field: 'id', header: 'ID', functionType: "none", selected: true },
        { field: 'type', header: 'Type', functionType: "none", selected: true },
        { field: 'ascendantSignName', header: 'Ascendant', functionType: "none", selected: true },
        { field: 'isPremium', header: 'Premium', functionType: "bool", selected: true },
        { field: 'startDate', header: 'Start Date', functionType: "Date", selected: true },
        { field: 'endDate', header: 'End Date', functionType: "Date", selected: true },
        { field: 'gender', header: 'Gender', functionType: "none", selected: true },
        { field: 'minAge', header: 'Min Age', functionType: "none", selected: true },
        { field: 'maxAge', header: 'Max Age', functionType: "none", selected: true },
        { field: 'storyPrefix', header: 'Story Prefix', functionType: "none", selected: true },
        {field: "Actions", header: "Actions", functionType: "crud", created: false, edit: true, delete: true, translations: false, selected: true},
    ],
      filters: {
        type: 'weekly',
        isPremium: true,
        ascendantSignId: 3,
        startDateFrom: '2025-11-16',
        startDateTo: '2025-11-23'
      },
      showCreateModal: false,
      showEditModal: false,
      showEditLanguageModal: false,
      showDeleteModal: false,

      selectedObjId: null,
      selectedDeleteObj: null,
      selectedDeleteId: null,
      editTranslationContentId: null,

      signs: [],
      optionsList: [],
      relationshipOptions: [],
      occupationOptions: []
    };
  },
  created() {
    this.$appAxios
        .get("admin/global/signs")
        .then((resp) => {
          this.signs = resp.data;
        });

    this.$appAxios.get("admin/global/supported-languages")
        .then(resp => {
          this.optionsList = resp.data
        })
        .catch(err => {
          console.log(err)
        });
  },
  computed: {
    weeklyMonthlyQuery() {
      const params = new URLSearchParams();

      if (this.filters.type) {
        params.set('Type', this.filters.type);
      }

      if (this.filters.isPremium !== null && this.filters.isPremium !== undefined) {
        params.set('IsPremium', this.filters.isPremium);
      }

      if (this.filters.ascendantSignId) {
        params.set('AscendantSignId', this.filters.ascendantSignId);
      }

      if (this.filters.startDateFrom) {
        params.set(
            'StartDateFrom',
            new Date(this.filters.startDateFrom).toISOString()
        );
      }

      if (this.filters.startDateTo) {
        params.set(
            'StartDateTo',
            new Date(this.filters.startDateTo).toISOString()
        );
      }

      const qs = params.toString();
      return qs ? `?${qs}` : '';
    },
    createFormFields() {
      return [
        {
          label: 'Type',
          type: 'select',
          model: 'type',
          options: [
            { id: 'weekly', value: 'Weekly' },
            { id: 'monthly', value: 'Monthly' }
          ],
          id: 'id',
          value: 'value',
          required: true
        },
        {
          label: 'Gender',
          type: 'select',
          model: 'gender',
          options: [
            { id: 0, value: 'All' },
            { id: 1, value: 'Man' },
            { id: 2, value: 'Woman' },
            { id: 4, value: 'Other' }
          ],
          id: 'id',
          value: 'value',
          required: true
        },
        { label: 'Is Premium', type: 'switch', model: 'isPremium', required: false },
        { label: 'Auto Audio', type: 'switch', model: 'autoAudio', required: false },
        {
          label: 'Ascendant Sign',
          type: 'select',
          model: 'ascendantSignId',
          options: this.signs,
          id: 'id',
          value: 'name',
          required: true
        },
        { label: 'Story Prefix', type: 'text', model: 'storyPrefix', required: false },
        { label: 'Start Date', type: 'date', model: 'startDate', required: true },
        { label: 'End Date', type: 'date', model: 'endDate', required: true },
        { label: 'Min Age', type: 'number', model: 'minAge', required: true },
        { label: 'Max Age', type: 'number', model: 'maxAge', required: true },
        {
          label: 'Occupations',
          type: 'occupation',
          model: 'occupationIds',
          options: this.occupationOptions,
          id: 'id',
          value: 'name',
          required: true
        },
        {
          label: 'Relationships',
          type: 'relationship',
          model: 'relationshipIds',
          options: this.relationshipOptions,
          id: 'id',
          value: 'id',
          required: true
        },
        {
          label: 'Translations',
          type: 'objProperties',
          model: 'translations',
          obj: [
            { label: 'Language', type: 'drop', model: 'language', placeholder: 'Enter language', options: this.optionsList , id: 'id', value: 'name' },
            { label: 'Title', type: 'text', model: 'title', popoverText: 'Translation başlık', required: false },
            { label: 'Description', type: 'textarea', model: 'text', popoverText: 'Translation içeriği', required: false },
            { label: 'Audio Url', type: 'text', model: 'audioUrl', required: false },
          ],
          placeholder: 'Enter option',
          popoverText: '',
          required: true
        }
      ]
    },
    editFormFields() {
      return [
        {
          label: 'Type',
          type: 'select',
          model: 'type',
          options: [
            { id: 'weekly', value: 'Weekly' },
            { id: 'monthly', value: 'Monthly' }
          ],
          value: 'id',
          text: 'value',
          required: true
        },
        {
          label: 'Gender',
          type: 'select',
          model: 'gender',
          options: [
            { id: 0, value: 'All' },
            { id: 1, value: 'Man' },
            { id: 2, value: 'Woman' },
            { id: 4, value: 'Other' }
          ],
          value: 'id',
          text: 'value',
          required: true
        },
        {
          label: 'Is Premium',
          type: 'switch',
          model: 'isPremium',
          required: false
        },
        {
          label: 'Auto Audio',
          type: 'switch',
          model: 'autoAudio',
          required: false
        },
        {
          label: 'Ascendant Sign',
          type: 'select',
          model: 'ascendantSignId',
          options: this.signs,
          value: 'id',
          text: 'name',
          required: true
        },
        {
          label: 'Story Prefix',
          type: 'text',
          model: 'storyPrefix',
          required: false
        },
        {
          label: 'Start Date',
          type: 'date',
          model: 'startDate',
          required: true
        },
        {
          label: 'End Date',
          type: 'date',
          model: 'endDate',
          required: true
        },
        {
          label: 'Min Age',
          type: 'number',
          model: 'minAge',
          required: true
        },
        {
          label: 'Max Age',
          type: 'number',
          model: 'maxAge',
          required: true
        },
        {
          label: 'Occupations',
          type: 'occupation',
          model: 'occupationIds',
          options: this.occupationOptions,
          value: 'id',
          text: 'name',
          required: true
        },
        {
          label: 'Relationships',
          type: 'relationship',
          model: 'relationshipIds',
          options: this.relationshipOptions,
          value: 'id',
          text: 'id',
          required: true
        },
        {
          label: 'Translations',
          type: 'objProperties',
          model: 'translations',
          obj: [
            { label: 'Language', type: 'drop', model: 'language', placeholder: 'Enter language', options: this.optionsList , id: 'id', value: 'name' },
            { label: 'Title', type: 'text', model: 'title', popoverText: 'Translation başlık', required: false },
            { label: 'Description', type: 'textarea', model: 'text', popoverText: 'Translation içeriği', required: false },
            { label: 'Audio Url', type: 'text', model: 'audioUrl', required: false },
          ],
          placeholder: 'Enter option',
          popoverText: '',
          required: true
        }
      ]
    },

    apiHeaders() {
      return {
        'Accept-Language': this.$i18n?.locale || 'en',
        'Content-Type': 'application/json'
      }
    }
  },
  methods: {
    openCreateModal() {
      this.showCreateModal = true
    },

    detailSee(row) {
      this.selectedObjId = row.id
      this.showEditModal = true
    },

    openDeleteModal(row) {
      this.selectedDeleteObj = row
      this.selectedDeleteId = row.id
      this.showDeleteModal = true
    },

    refreshTable() {
      this.$refs.astopiaTable?.getData()
    },

    async createObj(formData) {
      try {
        await this.$appAxios.post(
            '/admin/weekly-monthly',
            formData,
            { headers: this.apiHeaders }
        )
        this.refreshTable()
        this.showCreateModal = false
      } catch (e) {
        console.error('create weekly-monthly error', e)
        throw e
      }
    },
    async editObj(formData) {
      if (!this.selectedObjId) return
      try {
        await this.$appAxios.put(
            `/admin/weekly-monthly/${this.selectedObjId}`,
            formData,
            { headers: this.apiHeaders }
        )
        this.showEditModal = false
        this.refreshTable()
      } catch (e) {
        console.error('edit weekly-monthly error', e)
        throw e
      }
    },

    async bulkDeleteAll() {
      try {
        const selected = this.$refs.astopiaTable?.selectedRows || []
        const ids = selected.map(item => item.id)

        if (!ids.length) {
          this.$toast?.add({
            severity: 'warn',
            summary: 'Warning',
            detail: 'Lütfen silmek için en az bir kayıt seçin.',
            life: 3000
          })
          return
        }

        await this.$appAxios.post(
            '/admin/weekly-monthly/bulk-delete',
            { ids },
            { headers: this.apiHeaders }
        )

        this.$toast?.add({
          severity: 'success',
          summary: 'Success',
          detail: `${ids.length} kayıt silindi.`,
          life: 3000
        })

        this.$refs.astopiaTable.selectedRows = []
        this.refreshTable()
      } catch (e) {
        console.error('bulk delete weekly-monthly error', e)
        this.$toast?.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Toplu silme sırasında bir hata oluştu.',
          life: 3000
        })
      }
    },
    handleFileUpload(file) {
      if (!file) {
        return;
      }

      const formData = new FormData();
      formData.append('File', file);

      this.$appAxios.post('admin/weekly-monthly/csv-upload-v2', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
          .then(response => {
            Swal.fire('Başarılı!', 'Dosyanız başarıyla yüklendi.', 'success');
            console.log('Sunucu Cevabı:', response.data);
          })
          .catch(error => {
            Swal.fire('Hata!', 'Dosya yükleme sırasında bir sorun oluştu.', 'error');
            console.error('Yükleme Hatası:', error);
          });
    },
    openCsvUploadModal() {
      Swal.fire({
        title: 'CSV/Excel Dosyası Yükle',
        html: `
            <div style="text-align: left; margin-bottom: 20px;">
              <p>Lütfen yükleyeceğiniz dosyanın aşağıdaki formata uygun olduğundan emin olun.</p>
              <a href="https://docs.google.com/spreadsheets/d/1ha4ZL5O1Xza248eg1GeCdylKJ-ewNDhgbdli3eQRm9M/edit?gid=300583844#gid=300583844" download  target="_blank">Örnek CSV Dosyasını İndir</a>
            </div>
            <input type="file" id="fileInput" accept=".csv">
        `,
        showCancelButton: true,
        confirmButtonText: 'Yükle',
        cancelButtonText: 'İptal',
        preConfirm: () => {
          const file = document.getElementById('fileInput').files[0];
          if (!file) {
            Swal.showValidationMessage('Lütfen bir dosya seçin.');
            return false;
          }
          const fileExtension = file.name.split('.').pop().toLowerCase();
          const fileMimeType = file.type;
          if (fileExtension !== 'csv' || (fileMimeType !== 'text/csv' && fileMimeType !== 'application/vnd.ms-excel' && fileMimeType.indexOf('csv') === -1)) {
            Swal.showValidationMessage('Lütfen sadece CSV formatında bir dosya yükleyin.');
            return false;
          }

          return file;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleFileUpload(result.value);
        }
      });
    },
  }
};
</script>
